import { gql } from '@apollo/client';

export * from './backupAssetReport.query.generated';

export const BACKUP_ASSET_REPORT = gql`
  query backupAssetReport($backupId: ID!, $backupAssetReportId: ID!) {
    backupAssetReport(backupId: $backupId, backupAssetReportId: $backupAssetReportId) {
      id
      createdAt
      period
      backupAsset {
        id
        name
      }
      data {
        collaborators
        commitsPerDay
        languages
        size
        totalCommits
      }
    }
  }
`;
